var sys_global = require('../qiwa-static/sys_global');
var serverUrl = sys_global.webSettingsObject && ('//' + sys_global.webSettingsObject.siteUrl) 
	|| '//site.souche.com';

module.exports = {
	$weiDianGenerate: function (data) {
		return $.ajax({
			url: serverUrl + '/api/dfc/sharerecordapi/weiDianGenerate.json',
			type: 'GET',
			dataType: 'json',
			data: data
		});
	},
	weiDianGenerate: function (token, resData) {
		var _data = $.extend({
			salerPhone: '',
			title: '',
			shareLink: '',
			iconLink: '',
			shareType: 'WeiDianShare',
			_security_token: token
		}, resData);
		return this.$weiDianGenerate(_data).then(function (data) {
			if (!data.success) {
				return $.Deferred().reject(data.msg);
			}
			return data.data;
		});
	},
	_weiDianGenerateOnce: false,
	weiDianGenerateOnce: function (token, resData) {
		if (!this._generateOnce) {
			this._generateOnce = this.weiDianGenerate(token, resData);
		}
		return this._generateOnce;
	},

	$getWeiDianShareLink: function (data) {
		return $.ajax({
			url: serverUrl + '/api/dfc/sharerecordapi/getWeiDianShareLink.json',
			type: 'GET',
			dataType: 'json',
			data: data
		});
	},
	getWeiDianShareLink: function (token, resData) {
		var _data = $.extend({
			salerPhone: '',
			title: '',
			shareLink: '',
			iconLink: '',
			shareType: 'WeiDianShare',
			_security_token: token
		}, resData);
		return this.$getWeiDianShareLink(_data).then(function (data) {
			if (!data.success) {
				return $.Deferred().reject(data.msg);
			}
			return data.data;
		});
	},
	_getWeiDianShareLinkOnce: false,
	getWeiDianShareLinkOnce: function (token, resData) {
		if (!this._generateOnce) {
			this._generateOnce = this.getWeiDianShareLink(token, resData);
		}
		return this._generateOnce;
	}
}


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/share-service/sharerecordapi.js
// module id = 283
// module chunks = 4